const GoogleConversion = (transactionId, sendTo, value, currency) => {
  try {
    if (!process.browser || !window || !window.gtag) return false
    const data = {
      send_to: sendTo
    }
    if (transactionId) {
      data.transaction_id = transactionId
    }
    if (value !== undefined) {
      data.value = value
      data.currency = currency
    }
    return window.gtag('event', 'conversion', data)
  } catch (error) {
    console.error('Issue tracking traffic conversion', error)
    return false
  }
}

const conversions = {
  traffic: {
    manualFlow: {
      // user submitted a traffic ticket via manual submission
      submissionCompleted: transactionId =>
        GoogleConversion(transactionId, 'AW-970695970/RHt9CPLK6Z0BEKLK7s4D'),
      temp: transactionId => GoogleConversion(transactionId, 'AW-970695970/6sJLCO2B0-YBEKLK7s4D'),
      pendingConf: transactionId => GoogleConversion(transactionId, 'AW-970695970/HVPACL-XxsgBEKLK7s4D')
    },
    fetcherFlow: {
      // by looking up the user gives us information
      informationAdded: fetcherName =>
        GoogleConversion(undefined, 'AW-970695970/pdCCCK2iw-YBEKLK7s4D', 1.0, 'USD'),
      // user viewed results page (with tickets!)
      resultsPage: fetcherName =>
        GoogleConversion(undefined, 'AW-970695970/wVARCIfPjaYBEKLK7s4D', 1.0, 'USD'),
      // user viewed results page (with NO tickets!)
      noResultsPage: fetcherName => GoogleConversion(undefined, 'AW-970695970/5BFfCKz0qtUBEKLK7s4D'),
      // user submitted a traffic ticket via fetcher
      submissionCompleted: fetcherName =>
        GoogleConversion(undefined, 'AW-970695970/OQhfCPjugaYBEKLK7s4D')
    }
  },
  divorce: {
    fetcherFlow: {
      // by looking up the user gives us information
      informationAdded: fetcherName => GoogleConversion(undefined, 'AW-1045250664/Vh_NCNq_160aEOiEtfID'),
      // user viewed results page (with cases!)
      resultsPage: fetcherName => GoogleConversion(undefined, 'AW-1045250664/fZp_CN2_160aEOiEtfID'),
    }
  },
  parking: {
    fightFlow: {
      submissionCompleted: transactionId =>
        GoogleConversion(transactionId, 'AW-970695970/ACUrCIH49b8BEKLK7s4D')
    },
    payFlow: {
      submissionCompleted: transactionId =>
        GoogleConversion(transactionId, 'AW-970695970/dYPrCNzIkMABEKLK7s4D')
    },
    payFlowNYC: {
      resultsPage: () =>
          GoogleConversion(undefined,'AW-970695970/GeWPCNqD2ZoaEKLK7s4D'),
      submissionCompleted: transactionId =>{
        GoogleConversion(transactionId, 'AW-970695970/gAdsCJ3i1O8BEKLK7s4D')
        GoogleConversion(transactionId, 'AW-1045250664/HCEzCPCYo68cEOiEtfID')
      }
        
    },
    payAndFlow: {
      submissionCompleted: transactionId =>
        GoogleConversion(transactionId, 'AW-970695970/asalCND29b8BEKLK7s4D')
    }
  },
  plate: {
    plateCreated: transactionId =>
        GoogleConversion(transactionId, 'AW-970695970/j83GCLbvwuYBEKLK7s4D')
  },
  payments: {
    // user adds a payment method
    addPaymentMethod: () =>
      GoogleConversion(false, 'AW-970695970/7xo-CK-Jg6YBEKLK7s4D')
  },
  general: {
    // user signs up
    signup: transactionId =>
      GoogleConversion(transactionId, 'AW-970695970/H9K8CI3_hqYBEKLK7s4D')
  }
}

export default conversions
